import type { TranslationInterface } from '.';

export const MalteseLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Ikteb messaġġ...',
  your_issue_has_been_resolved: 'Il-problema tiegħek ġiet riżolta!',
  new_conversation: 'Konversazzjoni ġdida',
  welcome_screen_title: 'Merħba fis-support chat tagħna',
  welcome_screen_description:
    "Aħna hawn biex ngħinu! Ibda konversazzjoni u nirrispondu malajr kemm jista' jkun.",
  your_name_placeholder: 'Ismek',
  your_email_placeholder: 'L-indirizz tal-email tiegħek',
  start_chat_button: 'Kellem lis-support',
  start_chat_button_loading: 'Qed jikkonnettja...',
  i_need_more_help: 'Għandi bżonn aktar għajnuna',
  this_was_helpful: "Dan kien ta' għajnuna",
  optional: 'Mhux obbligatorju',
  no_conversations_yet: "Għad m'hemmx konversazzjonijiet",
  back_to_conversations: 'Lura għall-konversazzjonijiet',
  closed_conversations: 'Konversazzjonijiet magħluqa',
  csat_title: 'Kif kienet il-konversazzjoni tiegħek?',
  csat_submitted_title: 'Int ivvalutajt il-konversazzjoni bħala',
  csat_feedback_placeholder: 'Għidilna aktar... (mhux obbligatorju)',
  follow_up_placeholder: 'Kompli l-mistoqsija…',
  companion_layout_label: 'Tqassim',
  companion_layout_floating: 'Galleġġjanti',
  companion_layout_sidebar: 'Strixxa tal-ġenb',
  companion_layout_fullscreen: 'Skrin sħiħ',
  companion_close: 'Agħlaq',
  companion_history: 'Storja tal-konversazzjonijiet',
  companion_expand_chat: 'Kabbar iċ-chat',
  companion_sidebar_dock_label: 'Iddokkjar',
  companion_sidebar_side_label: 'Naħa',
  companion_sidebar_left: 'Xellug',
  companion_sidebar_right: 'Lemin',
  companion_resize_chat: 'Biddel id-daqs taċ-chat',
  scroll_to_bottom: 'Skrollja sal-qiegħ',
  thinking: 'Qed naħseb…',
  running: 'Qed jitħaddem…',
  steps: 'passi',
  step_arguments: 'Argumenti',
  step_result: 'Riżultat',
  attach_files:
    'Ehmeż stampi, vidjows, PDFs jew spreadsheets (daqs massimu 25 MB)',
  mark_page_active:
    'Ikklikkja xi ħaġa fil-paġna biex timmarkaha — Esc biex tikkanċella',
  mark_page: 'Immarka xi ħaġa fil-paġna biex tistaqsi dwarha',
  stop_response: 'Waqqaf it-tweġiba',
  copy_reply: 'Ikkopja t-tweġiba',
  mentions_empty: 'L-ebda riżultat',
  copied: 'Ikkupjat',
  send_message: 'Ibgħat messaġġ',
  upload_failed: 'It-tlugħ falla: {error}',
  remove_attachment: 'Neħħi s-sekwestru',
  json_no_items: 'L-ebda oġġett',
  json_no_data: 'L-ebda data',
  json_no_chart_data: 'L-ebda data għaċ-ċart',
  json_unsupported: 'Mhux appoġġjat: {type}',
  json_see_less: 'Ara inqas',
  json_phone_agent: 'Aġent tat-telefon',
  json_phone_agent_test: 'Ittestja fuq il-web',
  page_context_remove: 'Neħħi l-kuntest tal-paġna',
  json_see_more: 'Ara {count} oħra',
  queued_label: '{count} Fil-kju',
  remove_queued_message: 'Neħħi l-messaġġ mill-kju',
  send_queued_now: 'Ibgħat il-messaġġi fil-kju issa',
  turn_failed_message: 'Kien hemm problema u t-tweġiba ma waslitx.',
  turn_failed_retry: "Erġa' pprova",
  page_mark_hint: 'Ikklikkja xi ħaġa biex timmarkaha',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Kaxxa',
  page_mark_shape_circle: 'Ċirku',
  page_mark_shape_arrow: 'Vleġġa',
  page_mark_shape_bracket: 'Parentesi',
  page_mark_shape_underline: 'Issottolinjar',
  page_mark_shape_highlight: 'Immarkar',
  page_mark_shape_strike_through: "Qtugħ b'linja",
  page_mark_shape_crossed_off: "Qtugħ b'salib",
  page_mark_shape_aria: 'Forma tal-marka: {shape}',
  page_mark_note_placeholder: 'Żid nota… (Enter biex tehmeż)',
  page_mark_attach: 'Ehmeż il-marka',
  page_mark_remove: 'Neħħi {label}',
  page_mark_region: 'Żona mmarkata',
  page_mark_default_message: 'X’inhu dan?',
  file_rejected:
    'It-tip tal-fajl mhuwiex appoġġjat jew il-fajl huwa kbir wisq.',
  dictate: 'Iddetta',
  stop_dictation: 'Waqqaf id-dettatura',
  dictation_mic_blocked: 'Ippermetti l-aċċess għall-mikrofonu biex tiddetta',
  dictation_unavailable: 'Id-dettatura mhijiex disponibbli bħalissa',
  questions_back: 'Lura',
  questions_next: 'Li jmiss',
  questions_send: 'Ibgħat',
  questions_type_answer: 'Nikteb jien',
  questions_answer_placeholder: 'Ikteb it-tweġiba tiegħek…',
  close_conversation_title: 'Agħlaq il-konversazzjoni',
  close_conversation_description: 'Żgur li trid tagħlaq din il-konversazzjoni?',
  close_conversation_cancel: 'Le',
  close_conversation_confirm: 'Iva',
  dialog_close: 'Agħlaq',
  zoom_in: 'Kabbar',
  zoom_out: 'Ċekken',
  reset_zoom: 'Irrisettja ż-zoom',
  support_chat_aria_label: 'Chat ta’ appoġġ',
};
